
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/jobs/investment-banking",
      function () {
        return require("private-next-pages/jobs/investment-banking/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/jobs/investment-banking"])
      });
    }
  